<div class="action-item-container">
   <div class="count-container">
      <div #actionItemCount class="action-item-count" (click)="goToActionItems()">
         {{ actionItemCount$ | async }}
      </div>
   </div>
   <div class="action-item-text">open actions</div>
</div>
